export const ADMIN_EMAIL = 'ashfaaqmoosa@gmail.com';